/* eslint-disable max-len */
import { call, put, takeEvery } from "redux-saga/effects";
import Env from "Consts/env";
import {
	ActionsProducts,
	getApiSimilarProducts,
	failureSimilarProducts,
	loadSimilarProductsSuccess,
} from "./actions";

// Function Fetch Product
function* loadDataProducts(params = {}) {

	try {

		const endpoint = `${getApiSimilarProducts(params.payload.id)}`;
		const headers = { ...Env.HEADERS };
		const method = "GET";
		const options = { headers, method };

		const response = yield call(fetch, endpoint, options);
		if (typeof response.status !== "undefined" && response.status >= 200 && response.status < 300) {

			const self = yield response.json();

			yield put(loadSimilarProductsSuccess(self));

		} else {

			throw response;

		}

	} catch (err) {

		yield put(failureSimilarProducts(err));

	}

}

export default function* rootSaga() {

	yield takeEvery(ActionsProducts.GET_SIMILAR_PRODUCTS, loadDataProducts);

}
